import { render, staticRenderFns } from "./GraphInsecticides.vue?vue&type=template&id=8c9204f4&"
import script from "./GraphInsecticides.vue?vue&type=script&lang=js&"
export * from "./GraphInsecticides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports